import { createWasteheroPlatformRouteMap } from './routingMap'

export const routingMap = createWasteheroPlatformRouteMap('')
